import { configureStore } from '@reduxjs/toolkit'
import commonReducer from './common/slicers'

export const store = configureStore({
  /** Inject your reducers/slicers here */
  reducer: {
    common: commonReducer
  },
})